import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';

class AutomaticRouter extends Component {

	componentDidMount() {
		this.updateLocation(this.props.step);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.step !== nextProps.step) {
			this.updateLocation(nextProps.step);
		}
	}

	updateLocation = (step) => {
		const { history, location } = this.props;

		step = step !== 1 ? step : '';
		history.push(`/${step}${location.search}`);
	};

	render() {
		return null;
	}
}

export default compose(
	withRouter,
	connect((state) => ({
		step: state.app.step,
	}))
)(AutomaticRouter);



// WEBPACK FOOTER //
// ./src/components/AutomaticRouter.jsx